export default __webpack_public_path__ + "locales/pt-BR/HotkeysPanel.json?hash=fb4013a38576c8540260b7d90cefdcb0";